'use client';

import _defineProperty from "/codebuild/output/src4167/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/codebuild/output/src4167/src/s3/01/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function mergeStyles(styles, theme) {
  if (Array.isArray(styles)) {
    return _toConsumableArray(styles).reduce(function (acc, item) {
      return _objectSpread(_objectSpread({}, acc), mergeStyles(item, theme));
    }, {});
  }
  if (typeof styles === "function") {
    return styles(theme);
  }
  if (styles == null) {
    return {};
  }
  return styles;
}
function getBoxStyle(_ref) {
  var theme = _ref.theme,
    style = _ref.style,
    vars = _ref.vars,
    styleProps = _ref.styleProps;
  var _style = mergeStyles(style, theme);
  var _vars = mergeStyles(vars, theme);
  return _objectSpread(_objectSpread(_objectSpread({}, _style), _vars), styleProps);
}
export { getBoxStyle };